import { Approve } from './actions/Approve';
import { SafeTransferFrom } from './actions/SafeTransferFrom';
import { SetApprovalForAll } from './actions/SetApprovalForAll';
import { TransferFrom } from './actions/TransferFrom';
import { BalanceOf } from './getters/BalanceOf';
import { GetApproved } from './getters/GetApproved';
import { IsApprovedForAll } from './getters/IsApprovedForAll';
import { Name } from './getters/Name';
import { OwnerOf } from './getters/OwnerOf';
import { SupportsInterface } from './getters/SupportsInterface';
import { Symbol } from './getters/Symbol';
import { TokenURI } from './getters/TokenURI';
import { TotalSupply } from './getters/TotalSupply';
var actions = {
    Approve: Approve,
    SafeTransferFrom: SafeTransferFrom,
    SetApprovalForAll: SetApprovalForAll,
    TransferFrom: TransferFrom,
};
var getters = {
    TotalSupply: TotalSupply,
    BalanceOf: BalanceOf,
    GetApproved: GetApproved,
    IsApprovedForAll: IsApprovedForAll,
    Name: Name,
    OwnerOf: OwnerOf,
    SupportsInterface: SupportsInterface,
    Symbol: Symbol,
    TokenURI: TokenURI,
};
var ERC721 = {
    actions: actions,
    getters: getters,
};
export { ERC721 };
